import SimpleChoice from "../common/SimpleChoiceVO";
import {slugify} from "../common/SiteHelper";

export type NICounty = "antrim" | "armagh" | "down" | "derry_londonderry" | "fermanagh" | "tyrone" | "none";

export const NICounties:NICounty[] = ["antrim", "armagh", "down", "derry_londonderry", "fermanagh", "tyrone", "none"];

type INICounties = {
    [key in NICounty]: SimpleChoice
};

export default class GeneralManager
{
    counties: INICounties = {
        antrim: new SimpleChoice("antrim", "Antrim"),
        armagh: new SimpleChoice("armagh", "Armagh"),
        down: new SimpleChoice("down", "Down"),
        derry_londonderry: new SimpleChoice("derry_londonderry", "Derry~Londonderry"),
        fermanagh: new SimpleChoice("fermanagh", "Fermanagh"),
        tyrone: new SimpleChoice("tyrone", "Tyrone"),
        none: new SimpleChoice("none", "None")
    };

    getNiCounty(string:string):NICounty
    {
        string = string.trim().toLowerCase();
        if(NICounties.includes(string as NICounty)){
            return string as NICounty;
        }
        string = string.split("~").join("-");
        string = slugify(string);
        const parts = string.split("-");
        for(let part of parts){
            if((part === "derry" )|| (part === "londonderry")){
                return "derry_londonderry";
            }
        }
        return "none";
    }
}